<template>
  <div>
    <div class="layout hinnn-layout hinnn-layout-has-sider height-100-per" style="background: #fff">
      <content class="hinnn-layout-content" style="border-left: 1px solid #e8e8e8">
        <div class="container-fluid height-100-per print-content">
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-3 col-md-2" style="padding-right: 0px">
                  <div class="rect-printElement-types hiprintEpContainer">
                    <ul class="hiprint-printElement-type">
                      <li>
                        <span class="title"><code>拖拽列表</code></span>
                        <ul>
                          <li>
                            <a class="ep-draggable-item" tid="testModule.text" style="">
                              <span class="glyphicon glyphicon-text-width" aria-hidden="true"></span>
                              <span class="glyphicon-class">文本</span>
                            </a>
                          </li>

                          <li>
                            <a class="ep-draggable-item" tid="testModule.image" style="">
                              <span class="glyphicon glyphicon-picture" aria-hidden="true"></span>
                              <span class="glyphicon-class">图片2</span>
                            </a>
                          </li>
                          <li>
                            <a class="ep-draggable-item" tid="testModule.longText">
                              <span class="glyphicon glyphicon-subscript" aria-hidden="true"></span>
                              <span class="glyphicon-class">长文</span>
                            </a>
                          </li>

                          <li>
                            <a class="ep-draggable-item" tid="testModule.tableCustom" style="">
                              <span class="glyphicon glyphicon-th" aria-hidden="true"></span>
                              <span class="glyphicon-class">表格</span>
                            </a>
                          </li>

                          <li>
                            <a class="ep-draggable-item" tid="testModule.html">
                              <span class="glyphicon glyphicon-header" aria-hidden="true"></span>
                              <span class="glyphicon-class">html</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-sm-9 col-md-10">
                  <div class="hiprint-toolbar" style="margin-top: 15px">
                    <ul>
                      <li><a class="hiprint-toolbar-item" @click="setPaper('A3')">A3</a></li>
                      <li><a class="hiprint-toolbar-item" @click="setPaper('A4')">A4</a></li>
                      <li><a class="hiprint-toolbar-item" @click="setPaper('A5')">A5</a></li>
                      <li><a class="hiprint-toolbar-item" @click="setPaper('B3')">B3</a></li>
                      <li><a class="hiprint-toolbar-item" @click="setPaper('B4')">B4</a></li>
                      <li><a class="hiprint-toolbar-item" @click="setPaper('B5')">B5</a></li>

                      <li>
                        <a class="hiprint-toolbar-item"><input type="text" id="customWidth" style="width: 50px; height: 19px; border: 0px" placeholder="宽/mm" v-model="customWidth" /></a>
                      </li>
                      <li>
                        <a class="hiprint-toolbar-item"><input type="text" id="customHeight" style="width: 50px; height: 19px; border: 0px" placeholder="高/mm" v-model="customHeight" /></a>
                      </li>

                      <li><a class="hiprint-toolbar-item" @click="setPaper(customWidth, customHeight)">自定义</a></li>
                      <li><a class="hiprint-toolbar-item" @click="rotatePaper()">旋转</a></li>
                      <li><a class="hiprint-toolbar-item" @click="clearTemplate()">清空</a></li>

                      <li>
                        <a class="btn hiprint-toolbar-item" style="color: #fff; background-color: #d9534f; border-color: #d43f3a" id="A4_preview">快速预览</a>
                      </li>
                      <li>
                        <a id="A4_directPrint" class="btn hiprint-toolbar-item" style="color: #fff; background-color: #d9534f; border-color: #d43f3a">打印</a>
                      </li>
                    </ul>
                    <div style="clear: both"></div>
                  </div>
                  <div id="hiprint-printTemplate" class="hiprint-printTemplate" style="margin-top: 20px"></div>
                  <div style="padding-top: 15px">
                    <button type="button" class="btn btn-primary" id="A4_getJson_toTextarea">生成json到textarea</button>
                  </div>
                  <div class="hinnn-callout hinnn-callout-danger">
                    <p><code>可视化</code>结果以Json的形式存在，用户可以<code>编辑Json</code>实现特殊化操作，如：数据<code>formatter</code>，<code>文本变色</code>,单元格<code>改变背景</code>等。具体请参考文档。</p>
                  </div>
                  <textarea class="form-control" rows="10" id="A4_textarea_json"></textarea>
                  <div style="padding: 15px 0">
                    <button type="button" class="btn btn-danger" id="A4_getHtml_toTextarea">生成html到textarea</button>
                  </div>

                  <textarea class="form-control" rows="10" id="A4_textarea_html"> </textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog modal-lg" role="document" style="width: 825px">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="myModalLabel">打印预览</h4>
              </div>

              <div class="modal-body">
                <button type="button" class="btn btn-danger" id="A4_printByHtml">打印</button>
                <div class="prevViewDiv"></div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </content>
    </div>
  </div>
</template>
<script>
import logo from "@/assets/logo.png"
var customElementTypeProvider = (function () {
  return function (options) {
    var addElementTypes = function (context) {
      context.addPrintElementTypes("testModule", [
        new hiprint.PrintElementTypeGroup("常规", [
          { tid: "testModule.text", text: "文本", data: "", type: "text" },
          { tid: "testModule.image", text: "图片222", data: logo, type: "image" },
        ]),
      ]);
    };

    return {
      addElementTypes: addElementTypes,
    };
  };
})();
var customPrintJson = {
  panels: [
    {
      index: 0,
      height: 60,
      width: 100,
      paperHeader: 49.5,
      paperFooter: 780,
      printElements: [
        // {
        //   options: {
        //     left: 20,
        //     top: 0,
        //     height: 30,
        //     width: 100,
        //     title: "2205181526758081562611712",
        //     fontFamily: "微软雅黑",
        //     textAlign: "center",
        //     textType: "barcode",
        //   },
        //   printElementType: {
        //     title: "自定义文本",
        //     type: "text",
        //   },
        // },
        {
          options: {
            left: 10,
            top: 40,
            height: 60,
            width: 260,
            title: "S910000001",
            fontFamily: "微软雅黑",
            textAlign: "center",
            textType: "barcode",
            letterSpacing:3,
            fontWeight:'800'
          },
          printElementType: {
            title: "自定义文本",
            type: "text",
          },
        },
      ],
    },
  ],
};
export default {
  name: "",
  data() {
    return {
      hiprintTemplate: "",
      customWidth: "",
      customHeight: "",
    };
  },
  methods: {
    //调整纸张
    setPaper(paperTypeOrWidth, height) {
      this.hiprintTemplate.setPaper(paperTypeOrWidth, height);
    },
    //旋转
    rotatePaper() {
      this.hiprintTemplate.rotatePaper();
    },
    //清空
    clearTemplate() {
      this.hiprintTemplate.clear();
    },
  },
  mounted() {
    var _this = this;
    $(document).ready(function () {
      //初始化打印插件
      hiprint.init({
        providers: [new customElementTypeProvider()],
      });

      //hiprint.PrintElementTypeManager.build('.hiprintEpContainer', 'testModule');
      //设置左侧拖拽事件
      hiprint.PrintElementTypeManager.buildByHtml($(".ep-draggable-item"));

      _this.hiprintTemplate = new hiprint.PrintTemplate({
        template: customPrintJson,
        settingContainer: "#PrintElementOptionSetting",
        paginationContainer: ".hiprint-printPagination",
      });
      //打印设计
      _this.hiprintTemplate.design("#hiprint-printTemplate");

      $("#A4_preview").click(function () {
        $("#myModal .modal-body .prevViewDiv").html(_this.hiprintTemplate.getHtml({}));
        $("#myModal").modal("show");
      });
      $("#A4_directPrint").click(function () {
        _this.hiprintTemplate.print({});
      });
      $("#A4_printByHtml").click(function () {
        _this.hiprintTemplate.printByHtml($("#myModal .modal-body .prevViewDiv"));
      });
      $("#A4_getJson_toTextarea").click(function () {
        $("#A4_textarea_json").html(JSON.stringify(_this.hiprintTemplate.getJson()));
      });
      $("#A4_getHtml_toTextarea").click(function () {
        $("#A4_textarea_html").val(_this.hiprintTemplate.getHtml({})[0].outerHTML);
      });
    });

    //调整纸张
    var setPaper = function (paperTypeOrWidth, height) {
      _this.hiprintTemplate.setPaper(paperTypeOrWidth, height);
    };

    //旋转
    var rotatePaper = function () {
      _this.hiprintTemplate.rotatePaper();
    };
    var clearTemplate = function () {
      _this.hiprintTemplate.clear();
    };
  },
};
</script>
<style lang="less" scoped>

/* hiprint-pagination */
.hiprint-pagination {
    display: inline-block;
    padding-left: 0;
}
    .hiprint-pagination > li {
        border: 1px solid #bdc3c7;
        -moz-border-radius: 2px;
        -webkit-border-radius: 2px;
        display: block;
        float: left;
        padding: 5px;
        text-decoration: none;
        margin-right: 5px;
        margin-bottom: 5px;
        font-family: helvetica;
        font-size: 13px;
        cursor: pointer
    }

        .hiprint-pagination > li > span {
            padding: 0 10px 0 10px;
        }

        .hiprint-pagination > li > a {
            color: #bdc3c7;
            font-weight: bold;
            text-decoration: none;
            font-size: 11px;
            padding: 3px;
        }

            .hiprint-pagination > li > a:hover {
                color: red;
            }



.hiprint-pagination-sm > li > a {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
}
/*rect-printElement-type hiprint-printElement-type */
.rect-printElement-types .hiprint-printElement-type {
    display: block;
}

.rect-printElement-types .hiprint-printElement-type {
    padding: 0 0 0 0;
    list-style: none;
}

    .rect-printElement-types .hiprint-printElement-type > li > .title {
        display: block;
        padding: 4px 0px;
        clear: both;
    }

    .rect-printElement-types .hiprint-printElement-type > li > ul {
        padding: 0 0 0 0;
        display: block;
        list-style: none;
    }

        .rect-printElement-types .hiprint-printElement-type > li > ul > li {
            display: block;
            width: 50%;
            float: left;
            max-width: 100px;
        }

            .rect-printElement-types .hiprint-printElement-type > li > ul > li > a {
                height: 92px;
                padding: 12px 6px;
                margin-left: -1px;
                line-height: 1.42857143;
                color: #337ab7;
                text-decoration: none;
                background-color: #fff;
                border: 1px solid #ddd;
                margin-right: 5px;
                width: 95%;
                max-width: 100px;
                display: inline-block;
                text-align: center;
                margin-bottom: 7px;
                box-sizing: border-box;
                color: #b9a5a6;
                border: 1px solid rgba(0,0,0,0.2);
                border-radius: 3px;
                box-shadow: 0 1px 0 0 rgba(0,0,0,0.15);
            }


/*small-printElement-type hiprint-printElement-type */
.small-printElement-types .hiprint-printElement-type {
    display: block;
}

.small-printElement-types .hiprint-printElement-type {
    padding: 0 0 0 0;
    list-style: none;
}

    .small-printElement-types .hiprint-printElement-type > li > .title {
        display: block;
        padding: 4px 0px;
        clear: both;
    }

    .small-printElement-types .hiprint-printElement-type > li > ul {
        padding: 0 0 0 0;
        display: block;
        list-style: none;
        width: 100%;
    }

        .small-printElement-types .hiprint-printElement-type > li > ul > li {
            display: block;
            width: 50%;
            float: left;
            padding: 0 4px;
        }

            .small-printElement-types .hiprint-printElement-type > li > ul > li > a {
                height: 22px;
                /* padding: 12px 6px; */
                /* margin-left: -1px; */
                line-height: 20px;
                color: #337ab7;
                text-decoration: none;
                background-color: #fff;
                border: 1px solid #ddd;
                margin-right: 5px;
                width: 100%;
                display: block;
                text-align: center;
                margin-bottom: 7px;
                box-sizing: border-box;
                color: #b9a5a6;
                border: 1px solid rgba(0,0,0,0.2);
                border-radius: 3px;
                box-shadow: 0 1px 0 0 rgba(0,0,0,0.15);
            }


/* hiprint-toolbar*/

.hiprint-toolbar {
}

    .hiprint-toolbar > ul {
        padding: 0px;
        margin-bottom: 5px;
    }

        .hiprint-toolbar > ul > li {
            display: inline-block;
        }

            .hiprint-toolbar > ul > li > a {
                position: relative;
                float: left;
                padding: 3px 10px;
                margin-left: -1px;
                line-height: 1.42857143;
                color: #337ab7;
                text-decoration: none;
                background-color: #fff;
                border: 1px solid #ddd;
                margin-right: 4px;
                cursor: pointer;
            }


.hiprint-printElement-type .glyphicon-class {
    display: block;
    text-align: center;
    word-wrap: break-word;
    /*font-size: 0.65rem;
font-weight: normal;*/
    font-family: Helvetica, sans-serif;
}

.hiprint-printElement-type .glyphicon {
    margin-top: 5px;
    margin-bottom: 10px;
    font-size: 37px;
}


/*


*/

/*option css*/
/*option css*/
.hiprint-option-items {
    font-size: .75rem;
    padding: 10px 5px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    box-sizing: border-box;
    width: 100%;
}

    .hiprint-option-items .hiprint-option-item {
        box-sizing: border-box;
        float: left;
        width: 50%;
        margin-bottom: 5px;
        padding: 0 5px;
    }

    .hiprint-option-items .hiprint-option-item-row {
        width: 100%;
    }

.hiprint-option-item-label {
    margin: 5px 5px 3px 0;
}

.hiprint-option-items .hiprint-option-item-field input, .hiprint-option-items .hiprint-option-item-field select, .hiprint-option-items .hiprint-option-item-field textarea {
    color: inherit;
    background-color: transparent;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    padding: 3px;
    z-index: 1;
    border: 1px solid rgb(169, 169, 169);
    height: 19pt;
}

.hiprint-option-item-settingBtn {
    height: 19pt;
    line-height: 19pt;
    font-size: 12px;
    padding: 0 24px;
    background: #00c1de;
    border-color: transparent;
    color: #fff;
    display: inline-block;
    margin: 5px;
    font-weight: 400;
    border: 1px solid transparent;
    font-family: PingFangSC, helvetica neue, hiragino sans gb, arial, microsoft yahei ui, microsoft yahei, simsun, "sans-serif";
    vertical-align: middle;
    transition: .3s cubic-bezier(.4, 0, .2, 1);
    transform: translateZ(0);
}

.hiprint-option-item-deleteBtn {
    background: red;
}

.hiprint-option-items .minicolors {
    position: relative;
}

.hiprint-option-items .minicolors-sprite {
    background-image: url(./jquery.minicolors.png);
}

.hiprint-option-items .minicolors-swatch {
    position: absolute;
    vertical-align: middle;
    background-position: -80px 0;
    cursor: text;
    padding: 0;
    margin: 0;
    display: inline-block;
}

.hiprint-option-items .minicolors-swatch-color {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.hiprint-option-items .minicolors input[type=hidden] + .minicolors-swatch {
    width: 28px;
    position: static;
    cursor: pointer;
}

.hiprint-option-items .minicolors input[type=hidden][disabled] + .minicolors-swatch {
    cursor: default;
}

/* Panel */
.hiprint-option-items .minicolors-panel {
    position: absolute;
    width: 173px;
    background: white;
    border: solid 1px #CCC;
    box-shadow: 0 0 20px rgba(0, 0, 0, .2);
    z-index: 99999;
    box-sizing: content-box;
    display: none;
}

    .hiprint-option-items .minicolors-panel.minicolors-visible {
        display: block;
    }

/* Panel positioning */
.hiprint-option-items .minicolors-position-top .minicolors-panel {
    top: -154px;
}

.hiprint-option-items .minicolors-position-right .minicolors-panel {
    right: 0;
}

.hiprint-option-items .minicolors-position-bottom .minicolors-panel {
    top: auto;
}

.hiprint-option-items .minicolors-position-left .minicolors-panel {
    left: 0;
}

.hiprint-option-items .minicolors-with-opacity .minicolors-panel {
    width: 194px;
}

.hiprint-option-items .minicolors .minicolors-grid {
    position: relative;
    top: 1px;
    left: 1px; /* LTR */
    width: 150px;
    height: 150px;
    margin-bottom: 2px;
    background-position: -120px 0;
    cursor: crosshair;
}

.hiprint-option-items .minicolors .minicolors-grid-inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    height: 150px;
}

.hiprint-option-items .minicolors-slider-saturation .minicolors-grid {
    background-position: -420px 0;
}

.hiprint-option-items .minicolors-slider-saturation .minicolors-grid-inner {
    background-position: -270px 0;
    background-image: inherit;
}

.hiprint-option-items .minicolors-slider-brightness .minicolors-grid {
    background-position: -570px 0;
}

.hiprint-option-items .minicolors-slider-brightness .minicolors-grid-inner {
    background-color: black;
}

.hiprint-option-items .minicolors-slider-wheel .minicolors-grid {
    background-position: -720px 0;
}

.hiprint-option-items .minicolors-slider,
.hiprint-option-items .minicolors-opacity-slider {
    position: absolute;
    top: 1px;
    left: 152px; /* LTR */
    width: 20px;
    height: 150px;
    background-color: white;
    background-position: 0 0;
    cursor: row-resize;
}

.hiprint-option-items .minicolors-slider-saturation .minicolors-slider {
    background-position: -60px 0;
}

.hiprint-option-items .minicolors-slider-brightness .minicolors-slider {
    background-position: -20px 0;
}

.hiprint-option-items .minicolors-slider-wheel .minicolors-slider {
    background-position: -20px 0;
}

.hiprint-option-items .minicolors-opacity-slider {
    left: 173px; /* LTR */
    background-position: -40px 0;
    display: none;
}


.hiprint-option-items .minicolors-with-opacity .minicolors-opacity-slider {
    display: block;
}

/* Pickers */
.hiprint-option-items .minicolors-grid .minicolors-picker {
    position: absolute;
    top: 70px;
    left: 70px;
    width: 12px;
    height: 12px;
    border: solid 1px black;
    border-radius: 10px;
    margin-top: -6px;
    margin-left: -6px;
    background: none;
}

    .hiprint-option-items .minicolors-grid .minicolors-picker > div {
        position: absolute;
        top: 0;
        left: 0;
        width: 8px;
        height: 8px;
        border-radius: 8px;
        border: solid 2px white;
        box-sizing: content-box;
    }

.hiprint-option-items .minicolors-picker {
    position: absolute;
    top: 0;
    left: 0;
    width: 18px;
    height: 2px;
    background: white;
    border: solid 1px black;
    margin-top: -2px;
    box-sizing: content-box;
}

/* Swatches */
.hiprint-option-items .minicolors-swatches,
.hiprint-option-items .minicolors-swatches li {
    margin: 5px 0 3px 5px; /* LTR */
    padding: 0;
    list-style: none;
    overflow: hidden;
}

    .hiprint-option-items .minicolors-swatches .minicolors-swatch {
        position: relative;
        float: left; /* LTR */
        cursor: pointer;
        margin: 0 4px 0 0; /* LTR */
    }


.hiprint-option-items .minicolors-with-opacity .minicolors-swatches .minicolors-swatch {
    margin-right: 7px; /* LTR */
}


.hiprint-option-items .minicolors-swatch.selected {
    border-color: #000;
}

/* Inline controls */
.hiprint-option-items .minicolors-inline {
    display: inline-block;
}

    .hiprint-option-items .minicolors-inline .minicolors-input {
        display: none !important;
    }

    .hiprint-option-items .minicolors-inline .minicolors-panel {
        position: relative;
        top: auto;
        left: auto; /* LTR */
        box-shadow: none;
        z-index: auto;
        display: inline-block;
    }



/* Bootstrap theme */
.hiprint-option-items .minicolors-theme-bootstrap .minicolors-swatch {
    z-index: 2;
    top: 3px;
    left: 3px;
    width: 17px;
    height: 17px;
}

.hiprint-option-items .minicolors-theme-bootstrap .minicolors-swatches .minicolors-swatch {
    margin-bottom: 2px;
    top: 0;
    left: 0; /* LTR */
    width: 20px;
    height: 20px;
}

.hiprint-option-items .minicolors-theme-bootstrap .minicolors-swatch-color {
    border-radius: inherit;
}

.hiprint-option-items .minicolors-theme-bootstrap.minicolors-position-right > .minicolors-swatch {
    left: auto; /* LTR */
    right: 3px; /* LTR */
}

.hiprint-option-items .minicolors-theme-bootstrap .minicolors-input {
    float: none;
    padding-left: 23px; /* LTR */
}

.hiprint-option-items .minicolors-theme-bootstrap.minicolors-position-right .minicolors-input {
    padding-right: 44px; /* LTR */
    padding-left: 12px; /* LTR */
}

.hiprint-option-items .minicolors-theme-bootstrap .minicolors-input.input-lg + .minicolors-swatch {
    top: 4px;
    left: 4px; /* LTR */
    width: 37px;
    height: 37px;
    border-radius: 5px;
}

.hiprint-option-items .minicolors-theme-bootstrap .minicolors-input.input-sm + .minicolors-swatch {
    width: 24px;
    height: 24px;
}

.hiprint-option-items .minicolors-theme-bootstrap .minicolors-input.input-xs + .minicolors-swatch {
    width: 18px;
    height: 18px;
}

.hiprint-option-items .input-group .minicolors-theme-bootstrap:not(:first-child) .minicolors-input {
    border-top-left-radius: 0; /* LTR */
    border-bottom-left-radius: 0; /* LTR */
}



/*hitable reizer*/
.hitable {
}



    .hitable .selected {
        background: #3e66ad;
    }


    /*resizer*/
    .hitable tr.resizerRow,
    .hitable .resizerRow td {
        border: 0pt dashed;
        height: 0pt;
        background: #fff;
    }

        .hitable tr.resizerRow + tr,
        .hitable tr.resizerRow + tr td {
            border-top: 0px !important;
        }

    .hitable td.resizerColumn {
        border: 0pt dashed;
        width: 0.000001px !important;
        background: #fff;
    }


        .hitable td.resizerColumn + td {
            border-left: 0px !important;
        }


/*GRIP*/

.columngrips {
    height: 0px;
    position: absolute;
}

.columngrip {
    margin-left: -5px;
    position: absolute;
    z-index: 5;
    width: 10px;
}

    .columngrip .gripResizer {
        position: absolute;
        filter: alpha(opacity=1);
        opacity: 0;
        width: 10px;
        height: 100%;
        cursor: col-resize;
        top: 0px;
    }

.columngripDraging {
    border-left: 1px dotted black;
}

.rowgrips {
    height: 0px;
    width: 0px;
    position: absolute;
}

.rowgrip {
    margin-top: -5px;
    position: absolute;
    z-index: 5;
    height: 10px;
}

    .rowgrip .gripResizer {
        position: absolute;
        filter: alpha(opacity=1);
        opacity: 0;
        height: 10px;
        width: 100%;
        cursor: row-resize;
        left: 0px;
    }

.rowgripDraging {
    border-top: 1px dotted black;
}

.hitable .hitable-editor-text {
    border: 1px solid;
    width: 95%;
    height: 80%;
}




.hipanel-disable {
    height: 0px;
    display: block !important;
    top: 8500px;
    width: 0px;
    overflow: hidden;
    position: absolute;
}

.hiprint_rul_wrapper {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
    pointer-events: none;
    border: 0;
    border-top: 1px solid rgb(201, 190, 190);
    border-left: 1px solid rgb(201, 190, 190);
    padding-left: 15px;
    margin: -16px
}

    .hiprint_rul_wrapper .h_img {
        position: absolute;
        top: 0px;
        left: 15px;
        width: 400mm;
        height: 15px;
    }

    .hiprint_rul_wrapper .v_img {
        width: 400mm;
        transform: rotate(90deg);
        transform-origin: 0 100%;
        height: 15px;
        position: absolute;
        top: -2px;
        left: 0px;
    }

/*hiprint-option-table*/

.hiprint-option-table-selected-columns {
    color: inherit;
    background-color: transparent;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    padding: 0px;
    list-style: none;
}

    .hiprint-option-table-selected-columns .hiprint-option-table-selected-item {
        color: inherit;
        background-color: transparent;
        box-sizing: border-box;
        width: 100%;
        padding: 0 3px;
        border: 1px solid rgb(169, 169, 169);
        line-height: 19pt;
        margin: 3px 0;
    }
/*hi-pretty */
.hi-pretty * {
    box-sizing: border-box;
}

.hi-pretty input:not([type='checkbox']):not([type='radio']) {
    display: none;
}

.hi-pretty {
    position: relative;
    display: inline-block;
    margin-right: 1em;
    white-space: nowrap;
    line-height: 1;
}

    .hi-pretty input {
        position: absolute;
        left: 0;
        top: 0;
        min-width: 1em;
        width: 100%;
        height: 100%;
        z-index: 2;
        opacity: 0;
        margin: 0;
        padding: 0;
        cursor: pointer;
    }

    .hi-pretty .state label {
        position: initial;
        display: inline-block;
        font-weight: normal;
        margin: 0;
        text-indent: 1.5em;
        min-width: calc(1em + 2px);
    }

        .hi-pretty .state label:before,
        .hi-pretty .state label:after {
            content: '';
            width: calc(1em + 2px);
            height: calc(1em + 2px);
            display: block;
            box-sizing: border-box;
            border-radius: 0;
            border: 1px solid transparent;
            z-index: 0;
            position: absolute;
            left: 0;
            top: calc((0% - (100% - 1em)) - 8%);
            background-color: transparent;
        }

        .hi-pretty .state label:before {
            border-color: #bdc3c7;
        }

    .hi-pretty .state.p-is-hover,
    .hi-pretty .state.p-is-indeterminate {
        display: none;
    }


    .hi-pretty.p-default.p-fill .state label:after {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }

    .hi-pretty.p-default .state label:after {
        -webkit-transform: scale(0.6);
        -ms-transform: scale(0.6);
        transform: scale(0.6);
    }

    .hi-pretty.p-default input:checked ~ .state label:after {
        background-color: #bdc3c7 !important;
    }

    .hi-pretty.p-default.p-thick .state label:before,
    .hi-pretty.p-default.p-thick .state label:after {
        border-width: calc(1em / 7);
    }

    .hi-pretty.p-default.p-thick .state label:after {
        -webkit-transform: scale(0.4) !important;
        -ms-transform: scale(0.4) !important;
        transform: scale(0.4) !important;
    }

</style>
